import { Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import LandingPage from './pages/LandingPage'
import Dashboard from './pages/Dashboard'
import AppView from './pages/AppView'
import NotFoundPage from './pages/NotFoundPage'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  const location = useLocation()
  const isAppRoute = location.pathname.startsWith('/app/')

  return (
    <div className={`flex flex-col bg-hs-bg ${isAppRoute ? 'h-screen' : 'min-h-screen'}`}>
      <Navbar />
      <main className={`flex-1 flex flex-col min-h-0 ${isAppRoute ? 'pt-20' : ''}`}>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/app/:appId" element={<AppView />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ErrorBoundary>
      </main>
      {!isAppRoute && <Footer />}
    </div>
  )
}

export default App
